import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Edit, Trash } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Input } from "@air/primitive-input";
import classNames from "classnames";
import { useField } from "formik";
import { forwardRef, useEffect, useRef } from "react";
import { CustomField } from "~/components/CustomField";
import { CUSTOM_FIELD_DELETE_OPTION, CUSTOM_FIELD_MODAL_OPTION, CUSTOM_FIELD_MODAL_OPTION_INPUT, CUSTOM_FIELD_SAVE_OPTION } from "~/constants/testIDs";
import { CustomFieldModalColorMenu } from "./CustomFieldModalColorMenu";
const CustomFieldModalOption = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { colors, handleColorClick, handleDeleteItem, handleSaveOption, isSaveCurrentOptionDisabled = false, index, disableOptionClick = false, inEditMode, onToggleEditMode, option } = param;
    const inputRef = useRef(null);
    const fieldName = "values.".concat(index, ".value");
    const [field, meta] = useField(fieldName);
    useEffect(()=>{
        var _inputRef_current, _inputRef_current1;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.select();
    }, [
        inEditMode
    ]);
    if (inEditMode) {
        var _option_color;
        return /*#__PURE__*/ _jsxs("div", {
            "data-testid": "EDITING_CUSTOM_FIELD_OPTION",
            className: "relative flex h-10 items-center gap-2",
            children: [
                /*#__PURE__*/ _jsx(Input, {
                    ref: inputRef,
                    className: "w-full pl-9",
                    "data-1p-ignore": true,
                    size: "large",
                    "data-testid": "".concat(CUSTOM_FIELD_MODAL_OPTION_INPUT, "-").concat(option.value),
                    ...field
                }),
                !!meta.error && /*#__PURE__*/ _jsx("span", {
                    className: "absolute -bottom-5 text-12 text-red-9",
                    children: meta.error
                }),
                /*#__PURE__*/ _jsx(CustomFieldModalColorMenu, {
                    colors: colors,
                    fontHex: option.color.fontHex,
                    selectedColor: (_option_color = option.color) === null || _option_color === void 0 ? void 0 : _option_color.backgroundHex,
                    index: index,
                    handleColorClick: handleColorClick
                }),
                /*#__PURE__*/ _jsx(IconButton, {
                    onClick: handleSaveOption,
                    "data-testid": CUSTOM_FIELD_SAVE_OPTION,
                    size: "medium",
                    appearance: "filled",
                    color: "grey",
                    disabled: isSaveCurrentOptionDisabled,
                    icon: Check,
                    label: "Save"
                }),
                /*#__PURE__*/ _jsx(IconButton, {
                    "data-testid": CUSTOM_FIELD_DELETE_OPTION,
                    onClick: ()=>handleDeleteItem(index),
                    size: "medium",
                    appearance: "filled",
                    color: "grey",
                    icon: Trash,
                    label: "Delete"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "CUSTOM_FIELD_MODAL_OPTION",
        "data-optionid": option.id,
        className: classNames("h-10", disableOptionClick ? "pointer-events-none" : "pointer-events-auto"),
        onClick: onToggleEditMode,
        ref: ref,
        children: /*#__PURE__*/ _jsxs("button", {
            className: "group/custom-field-modal-options flex w-full cursor-pointer items-center justify-between rounded-4 p-2 hover:bg-grey-4",
            "data-testid": "".concat(CUSTOM_FIELD_MODAL_OPTION, "-").concat(option.value),
            type: "button",
            children: [
                /*#__PURE__*/ _jsx(CustomField, {
                    field: {
                        ...option,
                        value: option.value || ""
                    }
                }),
                /*#__PURE__*/ _jsx(Edit, {
                    className: "hidden size-4 group-hover/custom-field-modal-options:block"
                })
            ]
        })
    });
});
CustomFieldModalOption.displayName = "CustomFieldModalOption";
export { CustomFieldModalOption };
